module.exports = __webpack_public_path__ + "img/placeholder.a8c34afb.png";